import React from "react";

const Gender = ({
  gender,
  setGender,
  handleNext,
  userStoreUser,
  isSmallScreen,
}) => {
  const handleChangeGender = (event) => {
    setGender(event.target.value);
  };
  const handleSubmitGender = (e) => {
    e.preventDefault();
    userStoreUser.gender = gender;
    handleNext();
  };
  return (
    <>
      <div
        className="text-center mb-4"
        style={{
          lineHeight: "0.5rem",
          paddingRight: isSmallScreen ? "2rem" : "4rem",
        }}
      >
        <h3
          style={{
            fontFamily: "Playfair Display",
            fontWeight: 600,
            fontSize: isSmallScreen ? "1.6rem" : "2rem",
          }}
        >
          What is Your Gender?
        </h3>
        <p
          className="px-4"
          style={{
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: isSmallScreen ? "0.95rem" : "1.1rem",
            lineHeight: "1.5rem",
          }}
        >
          This helps us personalise your experience better.
        </p>
      </div>
      <form
        className="d-flex flex-column gap-3"
        style={{ paddingRight: isSmallScreen ? "2rem" : "4rem" }}
        onSubmit={(e) => handleSubmitGender(e)}
      >
        <div className="d-flex flex-column align-items-start">
          <label
            htmlFor="emailInput"
            style={{
              color: "black",
              fontFamily: "Open Sans",
              fontWeight: 400,
              fontSize: "0.8rem",
            }}
          >
            Gender
          </label>
          <select
            value={gender}
            className="form-control rounded-3"
            onChange={handleChangeGender}
            required
            style={{
              fontFamily: "Open Sans",
              fontWeight: 400,
              fontSize: "1rem",
              width: "100%",
            }}
          >
            <option value="" disabled>
              Select
            </option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>
        <button type="submit" className="btn btn-primary flex-grow-1 rounded-3">
          Next
        </button>
      </form>
    </>
  );
};

export default Gender;
